import { inject } from '@angular/core';

import { ModalRef } from '@frontend/sports/modal/feature';
import { WINDOW } from '@frontend/vanilla/core';

export class BetslipAutoCloseDialogService {
    private ref: ModalRef | null;
    private autoCloseTimeOut: number;
    /**
     * Auto close dialog fade out class. Found in betslip-edit-mybet.scss
     */
    private fadeOutClass = 'betslip-auto-close-dialog_fadeout';
    private readonly _window = inject(WINDOW);

    protected constructor() {}

    protected onShow(ref: ModalRef): void {
        this.ref = ref;
        const close = () => this.close(false);
        const autoClose = () => this.close(true);
        this.ref.result.then(close, close);
        this.autoCloseTimeOut = this._window.setTimeout(autoClose, 2000);

        this._window.setTimeout(this.fadeOut, 0);
    }

    private close(autoClose: boolean): void {
        if (this.ref) {
            if (autoClose) {
                // closed by timeout - close the dialog
                this.ref.close();
            } else {
                // closed by user click - clear timeout
                clearTimeout(this.autoCloseTimeOut);
            }
        }
        this.ref = null;
    }

    private fadeOut = () => this.ref && this.ref.addWindowClass(this.fadeOutClass).addBackdropClass(this.fadeOutClass);
}
